var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VContainer',{staticClass:"main--body--content"},[_c('VRow',[_c('VCol',{attrs:{"cols":"12"}},[_c('InputImage',{attrs:{"title":"File Uploader","placeholder":"https://uploadcare.com/jasf9028qitws/asfl;asf/3000x3000/light"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }